Vue.asyncComponent('q-r-code2-f-a', {
    props: {
        qr: {
            type: String,
            required: false
        }
    },
    methods: {
    }
}, 'cms/form/widget/qr-code-2fa.html');
